import { useSuspenseQuery } from "@tanstack/react-query";
import { myDashboardApi } from "@/features/my-dashboard/api";

const useGetMyDashboardProductByCategory = (buyer_id?: number) => {
  const { data: myDashboardProductByCategory } = useSuspenseQuery({
    queryFn: () =>
      myDashboardApi.getProductsByCategory({ buyer_id, max_depth: 2 }),
    queryKey: ["my-dashboard", "product-by-category", buyer_id],
    select: (data) =>
      data.map((category) => ({
        ...category,
        categories: category.categories.map((item) => ({
          ...item,
          category: item.category.replace(">", ""),
        })),
      })),
  });

  return {
    myDashboardProductByCategory,
  };
};

export default useGetMyDashboardProductByCategory;
